import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import { ButtonFollow } from './styled';

interface FollowButtonProps {
  isFollowed: boolean;
  onClick: () => void;
  [key: string]: any;
}

function FollowCompanyButton({
  isFollowed,
  onClick,
  ...props
}: FollowButtonProps) {
  const iconName = isFollowed ? 'icon-toolbar_check' : 'icon-toolbar_plus';

  return (
    <ButtonFollow
      {...props}
      onClick={onClick}
      // @ts-expect-error
      $isFollowed={isFollowed}
      height="30px"
    >
      <IconWrapper padding="0 12px 0 8px">
        <Iconmoon
          className={iconName}
          size="14px"
          isActive={isFollowed}
          hoverColor={color.highgray}
        />
        <Text padding="0 0 0 5px" color="inherit">
          {isFollowed ? 'Following' : 'Follow'}
        </Text>
      </IconWrapper>
    </ButtonFollow>
  );
}

export default FollowCompanyButton;
